import * as Ariakit from '@ariakit/react'
import '@components/tiptap/tiptap-ui-primitive/combobox/combobox.scss'
import { cn } from '@utils/tiptap-utils'
import { forwardRef } from 'react'

export function ComboboxProvider({ ...props }: Ariakit.ComboboxProviderProps) {
  return (
    <Ariakit.ComboboxProvider
      includesBaseElement={false}
      resetValueOnHide
      {...props}
    />
  )
}

export const ComboboxList = forwardRef<
  React.ComponentRef<typeof Ariakit.ComboboxList>,
  React.ComponentProps<typeof Ariakit.ComboboxList>
>(({ className, ...props }, ref) => {
  return (
    <Ariakit.ComboboxList
      ref={ref}
      className={cn('tiptap-combobox-list', className)}
      {...props}
    />
  )
})
ComboboxList.displayName = 'ComboboxList'

export const ComboboxPopover = forwardRef<
  React.ComponentRef<typeof Ariakit.ComboboxPopover>,
  React.ComponentProps<typeof Ariakit.ComboboxPopover>
>(({ className, ...props }, ref) => {
  return (
    <Ariakit.ComboboxPopover
      ref={ref}
      className={cn('tiptap-combobox-popover', className)}
      {...props}
    />
  )
})
ComboboxPopover.displayName = 'ComboboxPopover'

export const Combobox = forwardRef<
  React.ComponentRef<typeof Ariakit.Combobox>,
  React.ComponentProps<typeof Ariakit.Combobox>
>(({ className, ...props }, ref) => {
  return (
    <Ariakit.Combobox
      ref={ref}
      autoSelect
      {...props}
      className={cn('tiptap-combobox', className)}
    />
  )
})
Combobox.displayName = 'Combobox'

export const ComboboxItem = forwardRef<
  React.ComponentRef<typeof Ariakit.ComboboxItem>,
  React.ComponentProps<typeof Ariakit.ComboboxItem>
>(({ className, ...props }, ref) => {
  return (
    <Ariakit.ComboboxItem
      ref={ref}
      className={cn('tiptap-combobox-item', className)}
      {...props}
    />
  )
})
ComboboxItem.displayName = 'ComboboxItem'
